import React, { Fragment, useState, useEffect } from "react";
import { Col, Row, Card, CardBody, Button, Container, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import MomentUtils from '@date-io/moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from 'moment';
import TableComplaintsAndClaims from './TableComplaintsAndClaims';
import AnimatedBarComplaintsAndClaims from './AnimatedBarComplaintsAndClaims';
import Spinner from 'react-bootstrap/Spinner';
import classnames from 'classnames';

let months = [
    { mes: 'Enero', value: '01', number_value: 1 },
    { mes: 'Febrero', value: '02', number_value: 2 },
    { mes: 'Marzo', value: '03', number_value: 3 },
    { mes: 'Abril', value: '04', number_value: 4 },
    { mes: 'Mayo', value: '05', number_value: 5 },
    { mes: 'Junio', value: '06', number_value: 6 },
    { mes: 'Julio', value: '07', number_value: 7 },
    { mes: 'Agosto', value: '08', number_value: 8 },
    { mes: 'Septiembre', value: '09', number_value: 9 },
    { mes: 'Octubre', value: '10', number_value: 10 },
    { mes: 'Noviembre', value: '11', number_value: 11 },
    { mes: 'Diciembre', value: '12', number_value: 12 }
]

const ComplaintsAndClaims = ({ }) => {

    const [activeTab, setActiveTab] = useState('1');
    const [starterDate, setStarterDate] = useState(null);
    const [finalDate, setFinalDate] = useState(null);
    const [data, setData] = useState([]);
    const [data2, setData2] = useState([]);
    const [titleData, setTitleData] = useState(null);
    const [titleData2, setTitleData2] = useState(null);
    const [loading, setLoading] = useState(false);
    const [month1, setMonth1] = useState(null);
    const [month2, setMonth2] = useState(null);
    const [year1, setYear1] = useState(null);
    const [year2, setYear2] = useState(null);

    useEffect(() => {

    }, []);

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const getIndicadorComplaintsAndClaims = async () => {
        try {

            if (
                month1 != null &&
                month1 != undefined &&
                month2 != null &&
                month2 != undefined &&
                year1 != null &&
                year1 != undefined &&
                year2 != null &&
                year2 != undefined) {
                setLoading(true);

                let fecha_inicial1 = moment(`01/${month1}/${year1}`, 'DD/MM/YYYY').toDate();
                let fecha_final1 = moment(fecha_inicial1, 'DD/MM/YYYY').add(1, 'months').subtract(1, 'days').toDate();

                let fecha_inicial2 = moment(`01/${month2}/${year2}`, 'DD/MM/YYYY').toDate();
                let fecha_final2 = moment(fecha_inicial2, 'DD/MM/YYYY').add(1, 'months').subtract(1, 'days').toDate();

                await fetch(process.env.REACT_APP_PUBLIC_URL + 'indicadores/quejas-reclamos-comparativa', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                    },
                    body: JSON.stringify({
                        fecha_inicio1: moment(`${moment(fecha_inicial1).format('YYYY/MM/DD')} 00:00:00`).format('YYYY-MM-DD HH:mm:ss'),
                        fecha_final1: moment(`${moment(fecha_final1).format('YYYY/MM/DD')} 23:59:59`).format('YYYY-MM-DD HH:mm:ss'),
                        fecha_inicio2: moment(`${moment(fecha_inicial2).format('YYYY/MM/DD')} 00:00:00`).format('YYYY-MM-DD HH:mm:ss'),
                        fecha_final2: moment(`${moment(fecha_final2).format('YYYY/MM/DD')} 23:59:59`).format('YYYY-MM-DD HH:mm:ss')
                    })
                }).then(response => {
                    if (response.status != 500 && response.status != 403) {
                        return response.json();
                    }
                    else {
                        throw new Error("Data");
                    }
                }).then(data => {

                    let title1 = `${months.find(mon => mon.value == month1).mes.toUpperCase()} ${year1}`;
                    let title2 = `${months.find(mon => mon.value == month2).mes.toUpperCase()} ${year2}`;

                    setTitleData(title1);
                    setTitleData2(title2);
                    setData(data.indicador.comparativa1);
                    setData2(data.indicador.comparativa2);
                    setLoading(false);
                    setActiveTab("1");
                }).catch((error) => {
                    setTitleData("Comparativa 1");
                    setTitleData2("Comparativa 2");
                    setData([]);
                    setData2([]);
                    setLoading(false);
                    setActiveTab("1");
                    console.error('Error:', error);
                });
            }
            else {
                alert("Las fechas a comparar son obligatorias");
            }
        }
        catch (e) {
            setLoading(false);
        }
    }

    return (
        <Fragment>
            <Row>
                <Col md={12}>
                    <div className="card__title">
                        <h5 className="bold-text">Quejas y Reclamos</h5>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col md={6} style={{ border: '1px solid #B2B8BF', marginTop: 5, borderRadius: 5 }}>
                    <h5>Comparativa 1</h5>
                    <Row>
                        <Col md={6}>
                            <TextField
                                id="select-month"
                                select
                                label="Seleccione el Año"
                                value={year1}
                                className='medical-material-form__field'
                                onChange={(event) => {
                                    setYear1(event.target.value);
                                }}
                                style={{ minWidth: '100%', maxWidth: '100%' }}
                            >
                                <MenuItem key={0} value={2020}>2020</MenuItem>
                                <MenuItem key={1} value={2021}>2021</MenuItem>
                                <MenuItem key={2} value={2022}>2022</MenuItem>
                            </TextField>
                            <br /><br />
                        </Col>
                        <Col md={6}>
                            <TextField
                                id="select-month"
                                select
                                label="Seleccione el Mes"
                                value={month1}
                                className='medical-material-form__field'
                                onChange={(event) => {
                                    setMonth1(event.target.value);
                                }}
                                style={{ minWidth: '100%', maxWidth: '100%' }}
                            >
                                {
                                    months.map((month, index) => {
                                        return <MenuItem key={month.value} value={month.value}>{month.mes}</MenuItem>
                                    })
                                }
                            </TextField>
                            <br /><br />
                        </Col>
                    </Row>
                </Col>
                <Col md={6} style={{ border: '1px solid #B2B8BF', marginTop: 5, borderRadius: 5 }}>
                    <h5>Comparativa 2</h5>
                    <Row>
                        <Col md={6}>
                            <TextField
                                id="select-month"
                                select
                                label="Seleccione el Año"
                                value={year2}
                                className='medical-material-form__field'
                                onChange={(event) => {
                                    setYear2(event.target.value);
                                }}
                                style={{ minWidth: '100%', maxWidth: '100%' }}
                            >
                                <MenuItem key={0} value={2020}>2020</MenuItem>
                                <MenuItem key={1} value={2021}>2021</MenuItem>
                                <MenuItem key={2} value={2022}>2022</MenuItem>
                            </TextField>
                            <br /><br />
                        </Col>
                        <Col md={6}>
                            <TextField
                                id="select-month"
                                select
                                label="Seleccione el Mes"
                                value={month2}
                                className='medical-material-form__field'
                                onChange={(event) => {
                                    setMonth2(event.target.value);
                                }}
                                style={{ minWidth: '100%', maxWidth: '100%' }}
                            >
                                {
                                    months.map((month, index) => {
                                        return <MenuItem key={month.value} value={month.value}>{month.mes}</MenuItem>
                                    })
                                }
                            </TextField>
                            <br /><br />
                        </Col>
                    </Row>
                </Col>

            </Row>


            <Row>
                {/*<Col md={3}>
                    <MuiPickersUtilsProvider utils={MomentUtils} >
                        <KeyboardDatePicker
                            style={{ minWidth: '300px', maxWidth: '100%' }}
                            value={starterDate}
                            onChange={(date) => {
                                setStarterDate(date);
                            }}
                            label="Fecha Inicial"
                            format="DD/MM/YYYY"
                            animateYearScrolling
                            className='medical-material-form__field material-form__label'
                        />
                    </MuiPickersUtilsProvider>
                </Col>
                <Col md={3}>
                    <MuiPickersUtilsProvider utils={MomentUtils} >
                        <KeyboardDatePicker
                            style={{ minWidth: '300px', maxWidth: '100%' }}
                            value={finalDate}
                            onChange={(date) => {
                                setFinalDate(date);
                            }}
                            label="Fecha Final"
                            format="DD/MM/YYYY"
                            animateYearScrolling
                            className='medical-material-form__field material-form__label'
                        />
                    </MuiPickersUtilsProvider>
                </Col>
                */}
                <Col md={3}>
                    <Button
                        style={{ marginTop: 10, marginRight: 10 }}
                        variant="contained"
                        className="btn btn-primary text-white"
                        onClick={() => {
                            getIndicadorComplaintsAndClaims();
                        }}
                    >
                        Consultar
                    </Button>
                </Col>
                <br />

                {loading == false ?
                    <div>
                        {
                            data.length > 0 ? <Row>
                                <Col md={6}>
                                    <div className="tabs tabs--bordered-top">
                                        <div className="tabs__wrap">
                                            <Nav tabs>
                                                <NavItem>
                                                    <NavLink
                                                        className={classnames({ active: activeTab === '1' })}
                                                        onClick={() => {
                                                            toggle('1');
                                                        }}
                                                    >
                                                        {titleData}
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink
                                                        className={classnames({ active: activeTab === '2' })}
                                                        onClick={() => {
                                                            toggle('2');
                                                        }}
                                                    >
                                                        {titleData2}
                                                    </NavLink>
                                                </NavItem>
                                            </Nav>
                                            <TabContent activeTab={activeTab}>
                                                <TabPane tabId="1">
                                                    <TableComplaintsAndClaims reactTableData={data} />
                                                </TabPane>
                                                <TabPane tabId="2">
                                                    <TableComplaintsAndClaims reactTableData={data2} />
                                                </TabPane>
                                            </TabContent>
                                        </div>
                                    </div>


                                </Col>
                                <Col md={6}>
                                    <AnimatedBarComplaintsAndClaims dataIndicator={data} dataIndicator2={data2} titleData={titleData} titleData2={titleData2} />
                                </Col>
                            </Row> : null
                        }
                    </div> : <div className="text-center">
                        <Spinner animation="border" variant="success" />
                    </div>}

            </Row>
        </Fragment>
    );
}
export default ComplaintsAndClaims;